// Message Origin
const origin = "*";

// Send message to clear map selection
export const handleClearSelection = () => {
    window.parent.postMessage(
        {
            message: "clearMapSelection",
        },
        origin
    );
    console.log("Clear map selection message sent.");
}

// Send message to clear map symbolic layer selection
export const clearProgrammaticLayers = () => {
    window.parent.postMessage(
        {
            message: "clearProgrammaticLayers",
        },
        origin
    );
    console.log("Clear map programmatic layers message sent.");
}

// Send message to clear map symbolic layer selection
export const clearSymbolicLayers = () => {
    window.parent.postMessage(
        {
            message: "clearSymbolicLayers",
        },
        origin
    );
    console.log("Clear map symbolic layers message sent.");
}

// Send message to clear all active programmatic and symbolic layers on the map
export const clearAllLayers = () => {
    clearProgrammaticLayers();
    clearSymbolicLayers();
}

export const toggleProgrammaticLayer = (id: number, name: string) => {
    window.parent.postMessage(
        {
            message: "toggleProgrammaticLayer",
            data: [{ id, name }],
        },
        origin
    );
    console.log("Toggle programmatic layer message sent:", [{ id, name }]);
}